import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {filter, map} from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import {AccountService} from "./account.service";
import {Order} from "../models/order";
import {Orders} from "../models/orders";
import {OrdersFilter} from "../models/ordersFilter";
import {User} from "../models";

@Injectable({ providedIn: 'root' })
export class OrderService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number, filters: OrdersFilter) {
        let filtersString = '';

        if (filters.dateRange.startDate !== null) {
            filtersString = filtersString + '&filters[documentDate]=' + filters.dateRange.startDate.toISOString();
        }

        if (filters.dateRange.endDate !== null) {
            filtersString = filtersString + '&filters[documentDateTo]=' + filters.dateRange.endDate.toISOString();
        }

        if (filters.customer !== null ) {
            filtersString = filtersString + '&filters[customer]=' + filters.customer;
        }

        return this.http.get<Orders>(`${environment.apiEndpoint}/v1/orders?offset=`+offset+`&limit=`+limit + filtersString, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getAllByCustomer(offset: number, limit: number, filters: OrdersFilter, customer: User) {
        let filtersString = '';

        if (filters.dateRange.startDate !== null) {
            filtersString = filtersString + '&filters[documentDate]=' + filters.dateRange.startDate.toISOString();
        }

        if (filters.dateRange.endDate !== null) {
            filtersString = filtersString + '&filters[documentDateTo]=' + filters.dateRange.endDate.toISOString();
        }

        return this.http.get<Orders>(`${environment.apiEndpoint}/v1/orders/users/` + customer.id + `?offset=`+offset+`&limit=`+limit + filtersString, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<Order>(`${environment.apiEndpoint}/v1/orders/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    update(id, params) {
        return this.http.put(`${environment.apiEndpoint}/v1/orders/${id}`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }

    create(params) {
        return this.http.post(`${environment.apiEndpoint}/v1/orders`, params, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
